export default __webpack_public_path__ + "static/boozin-crew-01e4707001cf5049ece780ab758753d8.jpg";